import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_3 = { class: "flex card-toolbar w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "p-input-icon-left w-10/12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "card-toolbar w-full" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = { class: "ml-96 mt-10" }

import {computed, onBeforeMount, onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import router from "@/router";
import ApiService from "@/_services/api.service";
import { useRoute } from 'vue-router';
import { fetchUrssafCategoriesByVariantProductCollection } from "@/_services/category/category";
import { IUrssafCategory } from "@/models/category/IUrssafCategory";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'EditSocialEventGrantCollection',
  setup(__props) {

const getTableLocalStorageKey = () => {
    const uuid = route.params.uuid as string;
    return `tableSelectedCategoriesToMap_${uuid}`;
};

const getSelectedCategoryToMapStorageKey = () => {
    const uuid = route.params.uuid as string;
    return `selectedCategoriesToMap_${uuid}`;
};

const getSelectAllBtnStatusStorageKey = () => {
    const uuid = route.params.uuid as string;
    return `selectAllCategoriesForMappingBtnStatus_${uuid}`;
};

const isSelectAllBtnChecked = ref<boolean>(false);
const refItemsPerPage = ref<number>(0);
const isLoading = ref<boolean>(true);
const categories = Array<IUrssafCategory>();
const tableData = ref<Array<IUrssafCategory>>(categories);
const allCategories = ref<Array<IUrssafCategory>>([]);
const totalSelectedCategories = ref<number>(0);
const categoriesOfCurrentPage = ref(Array<IUrssafCategory>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100, 250];
const isFormSubmitted = ref(false);
const selectedCategories = ref<IUrssafCategory[]>([]);
const category_model = ref<{uuid: string}>({uuid: ''});
const route = useRoute();

const preselectCategory = async () => {
    const categoryUuid = route.params.uuid as string;
    if (categoryUuid) {
        category_model.value = {
            uuid: categoryUuid
        };
    }
};

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
    await preselectCategory();
    await fetchAllCategories();
    const associatedEvents = await fetchAssociatedSocialEvents();
    if (associatedEvents && associatedEvents.length > 0) {
        const associatedCategoryIds = associatedEvents.map(event => createCategoryIdentifier(event));
        addSelectedCategoryInCategoriesToMapInStorage(associatedCategoryIds);
    }
    await populateDataTableWithLocalStorageFilters();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

const isInFilteredView = computed(() => {
    return totalSelectedCategories.value > 0;
});

const initLocalStorageData = () => {
    if (localStorage.getItem(getSelectAllBtnStatusStorageKey())) {
        localStorage.removeItem(getSelectAllBtnStatusStorageKey());
    }
    if (localStorage.getItem(getTableLocalStorageKey())) {
        localStorage.removeItem(getTableLocalStorageKey());
    }
    if (localStorage.getItem(getSelectedCategoryToMapStorageKey())) {
        localStorage.removeItem(getSelectedCategoryToMapStorageKey());
    }

    if (!localStorage.getItem(getSelectAllBtnStatusStorageKey())) {
        localStorage.setItem(getSelectAllBtnStatusStorageKey(), 'false');
    }
    if (!localStorage.getItem(getSelectedCategoryToMapStorageKey())) {
        localStorage.setItem(getSelectedCategoryToMapStorageKey(), '[]');
    }
}

function createCategoryIdentifier(category: IUrssafCategory): string {
    if (category.uuid) {
        return `${category.uuid}`;
    }
    return `${category.id}__${category.name}`;
}

async function submitHandler() {
    showSpinner();
    try {
        const selectedCategoryIds = getSelectedCategoriesToMapFromStorage();
        
        const variantProductCollectionUuid = route.params.uuid as string;
        
        const selectedSocialEvents = allCategories.value
            .filter(socialEvent => {
                return selectedCategoryIds.includes(createCategoryIdentifier(socialEvent)) || 
                       socialEvent.isAssociated === true || 
                       socialEvent.isSelected === true;
            })
            .map(socialEvent => {
                return `/api/social_events/${socialEvent['uuid']}`;
            });
        
        const payload = {
            variantProductCollection: `/api/variant_product_collections/${variantProductCollectionUuid}`,
            socialEvents: selectedSocialEvents,
        };
        
        const response = await ApiService.post('variant_product_collection_social_events', payload);
        
        swal.success('Succès', 'Le(les) événement(s) social(aux) a/ont été associé(s) avec succès à la collection de produits variants.');
        
        setTimeout(() => {
            localStorage.removeItem(getTableLocalStorageKey());
            
            const routeLocation = router.resolve({ 
                name: 'editSocialEventGrantCollection', 
                params: { uuid: route.params.uuid },
                query: { page: 1 }
            });
            window.location.href = routeLocation.href;
            router.go(0);
        }, 1500);
    } catch (error: any) {
        // ... gestion des erreurs ...
    } finally {
        hideSpinner();
    }
}

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;
    const isSelectedAllBtnInStorageData = localStorage.getItem(getSelectAllBtnStatusStorageKey());
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(getSelectAllBtnStatusStorageKey(), status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(getSelectAllBtnStatusStorageKey(), status.toString());
        }
    }
}

const onSearchInputDt = () => {
    if (criteria.value.trim() != "") {
        populateDatatable(rows.value, page.value, criteria.value.trim());
    } else {
        populateDatatable(rows.value, page.value);
    }
}

async function populateDatatable(itemsPerPage: number, page: number, criteria: string) {
    isLoading.value = true;
    const variantProductCollectionUuid = route.params.uuid as string;
    const selectedCategoryIds = getSelectedCategoriesToMapFromStorage();
    
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchUrssafCategoriesByVariantProductCollection(
        itemsPerPage,
        page,
        variantProductCollectionUuid,
        criteria,
        undefined,
        selectedCategoryIds
    );

    totalRecords.value = totalRecordsDt.value;
    isLoading.value = loadingDt.value;
    
    tableDataDt.value.forEach(category => {
        const categoryId = createCategoryIdentifier(category);
        const existingCategory = allCategories.value.find(cat => createCategoryIdentifier(cat) === categoryId);
        
        if (existingCategory) {
            category.isSelected = existingCategory.isSelected;
        } else {
            category.isSelected = selectedCategoryIds.includes(categoryId) || category.isAssociated === true;
        }
    });
    
    tableData.value = tableDataDt.value;
    categoriesOfCurrentPage.value = tableDataDt.value;
    refItemsPerPage.value = categoriesOfCurrentPage.value.length;
    
    tableDataDt.value.forEach(category => {
        const existingCategory = allCategories.value.find(cat => createCategoryIdentifier(cat) === createCategoryIdentifier(category));
        if (!existingCategory) {
            allCategories.value.push(category);
        } else {
            existingCategory.isAssociated = category.isAssociated;
        }
    });

    const preSelectedCategories = tableData.value.filter(category => 
        category.isSelected === true || 
        selectedCategoryIds.includes(createCategoryIdentifier(category)) || 
        category.isAssociated === true
    );
    selectedCategories.value = preSelectedCategories;
    
    categoriesOfCurrentPage.value.forEach(category => {
        const categoryId = createCategoryIdentifier(category);
        if (selectedCategoryIds.includes(categoryId) || category.isAssociated === true) {
            category.isSelected = true;
        }
    });
    
    updateTotalSelectedCategories();

    isSelectAllBtnChecked.value = categoriesOfCurrentPage.value.length > 0 && 
        categoriesOfCurrentPage.value.every(category => 
            category.isSelected === true
        );

    hideSpinner();
}

function updateTotalSelectedCategories() {
    const selectedCategoryIds = getSelectedCategoriesToMapFromStorage();
    
    const associatedCategories = allCategories.value.filter(category => category.isAssociated === true);
    const associatedCategoryIds = associatedCategories.map(category => createCategoryIdentifier(category));
    
    const selectedButNotInStorage = allCategories.value.filter(category => 
        category.isSelected === true && 
        !selectedCategoryIds.includes(createCategoryIdentifier(category)) && 
        !associatedCategoryIds.includes(createCategoryIdentifier(category))
    );
    const selectedButNotInStorageIds = selectedButNotInStorage.map(category => createCategoryIdentifier(category));
    
    const uniqueSelectedIds = [...new Set([...selectedCategoryIds, ...associatedCategoryIds, ...selectedButNotInStorageIds])];
    totalSelectedCategories.value = uniqueSelectedIds.length;
}

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);

    await populateDatatable(rows.value, page.value, criteria.value);
    
    hideSpinner();
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

const onRowSelectAll = async (event): Promise<void> => {
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        
        selectedCategories.value = categoriesOfCurrentPage.value;
        
        const categoriesToSelect = categoriesOfCurrentPage.value.filter(category => 
            category.isSelected !== true
        );
        
        totalSelectedCategories.value += categoriesToSelect.length;
        
        categoriesOfCurrentPage.value.forEach(category => {
            category.isSelected = true;
        });
        
        const categoriesOfCurrentPageToSelect = categoriesOfCurrentPage.value
            .filter((item) => !getSelectedCategoriesToMapFromStorage().includes(createCategoryIdentifier(item)))
            .map(item => createCategoryIdentifier(item));
            
        if (categoriesOfCurrentPageToSelect.length > 0) {
            addSelectedCategoryInCategoriesToMapInStorage(categoriesOfCurrentPageToSelect);
        }
    } else {
        isSelectAllBtnChecked.value = false;
        
        const nonAssociatedCategories = categoriesOfCurrentPage.value.filter(category => category.isAssociated !== true);
        
        const selectedCategoriesOnCurrentPage = nonAssociatedCategories.filter(category => 
            category.isSelected === true
        ).length;
        
        totalSelectedCategories.value -= selectedCategoriesOnCurrentPage;
        
        nonAssociatedCategories.forEach(category => {
            category.isSelected = false;
        });
        
        const unSelectedCategoriesOfCurrentPageToRemoveInStorage = nonAssociatedCategories.map(item => createCategoryIdentifier(item));
        removeUnSelectedCategoryFromCategoriesToMapInStorage(unSelectedCategoriesOfCurrentPageToRemoveInStorage);
        
        const associatedCategories = categoriesOfCurrentPage.value.filter(category => category.isAssociated === true);
        selectedCategories.value = associatedCategories;
        
        categoriesOfCurrentPage.value.forEach(category => {
            const categoryInAllCategories = allCategories.value.find(cat => 
                createCategoryIdentifier(cat) === createCategoryIdentifier(category)
            );
            if (categoryInAllCategories) {
                categoryInAllCategories.isSelected = category.isAssociated === true;
            }
        });

        hideSpinner();
    }
};

const onRowSelect = async (event: any): Promise<void> => {
    const selectedCategory = event.data;
    const selectedCategoryId = createCategoryIdentifier(selectedCategory);
    
    selectedCategory.isSelected = true;
    
    const categoryInAllCategories = allCategories.value.find(cat => 
        createCategoryIdentifier(cat) === selectedCategoryId
    );
    if (categoryInAllCategories) {
        categoryInAllCategories.isSelected = true;
    }
    
    addSelectedCategoryInCategoriesToMapInStorage([selectedCategoryId]);
    
    updateTotalSelectedCategories();
    
    const selectedCategoryIds = getSelectedCategoriesToMapFromStorage();
    isSelectAllBtnChecked.value = categoriesOfCurrentPage.value.length > 0 && 
        categoriesOfCurrentPage.value.every(category => 
            selectedCategoryIds.includes(createCategoryIdentifier(category)) || category.isAssociated === true
        );
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedCategory = event.data;
    const unSelectedCategoryId = createCategoryIdentifier(unSelectedCategory);
    
    if (unSelectedCategory.isAssociated === true) {
        setTimeout(() => {
            unSelectedCategory.isSelected = true;
            dt.value.selection = [...dt.value.selection, unSelectedCategory];
        }, 0);
        return;
    }
    
    unSelectedCategory.isSelected = false;
    
    const categoryInAllCategories = allCategories.value.find(cat => 
        createCategoryIdentifier(cat) === unSelectedCategoryId
    );
    if (categoryInAllCategories) {
        categoryInAllCategories.isSelected = false;
    }
    
    removeUnSelectedCategoryFromCategoriesToMapInStorage([unSelectedCategoryId]);
    
    updateTotalSelectedCategories();

    const selectedCategoryIds = getSelectedCategoriesToMapFromStorage();
    isSelectAllBtnChecked.value = categoriesOfCurrentPage.value.length > 0 && 
        categoriesOfCurrentPage.value.every(category => 
            selectedCategoryIds.includes(createCategoryIdentifier(category)) || category.isAssociated === true
        );
}

const getSelectedCategoriesToMapFromStorage = (): string[] => {
    const selectedCategoriesToMap = localStorage.getItem(getSelectedCategoryToMapStorageKey());
    return selectedCategoriesToMap ? JSON.parse(selectedCategoriesToMap) : [];
}

const addSelectedCategoryInCategoriesToMapInStorage = (categoryIds: string[]) => {
    if (categoryIds.length === 0) {
        totalSelectedCategories.value = 0;
        localStorage.setItem(getSelectedCategoryToMapStorageKey(), JSON.stringify([]));
        return;
    }

    let categoriesToMapInStorage = getSelectedCategoriesToMapFromStorage();
    categoryIds.forEach(categoryId => {
        if (!categoriesToMapInStorage.includes(categoryId)) {
            categoriesToMapInStorage.push(categoryId);
        }
    });
    localStorage.setItem(getSelectedCategoryToMapStorageKey(), JSON.stringify(categoriesToMapInStorage));
}

const removeUnSelectedCategoryFromCategoriesToMapInStorage = (categoryIds: string[]) => {
    let categoriesToMapInStorage = getSelectedCategoriesToMapFromStorage();
    let newCategoriesToMapInStorage = categoriesToMapInStorage.filter(categoryId => !categoryIds.includes(categoryId));
    localStorage.setItem(getSelectedCategoryToMapStorageKey(), JSON.stringify(newCategoriesToMapInStorage));
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(getTableLocalStorageKey());
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(getTableLocalStorageKey());
    if (storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(getTableLocalStorageKey(), JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

async function populateDataTableWithLocalStorageFilters(itemsPerPage?: number, page?: number) {
    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    await populateDatatable(currentItemsPerPage, currentPage, criteria.value);
}

const fetchAssociatedSocialEvents = async () => {
    const variantProductCollectionUuid = route.params.uuid as string;
    try {
        const { data } = await ApiService.get(`variant_product_collection_all_social_events`, {
            params: { "variantProductCollection.uuid": variantProductCollectionUuid },
            headers: { Accept: "application/ld+json" },
        });
        
        const allSocialEvents = data.data.socialEvents;
        const associatedSocialEvents = allSocialEvents.filter(event => event.isAssociated === true);
        
        return associatedSocialEvents;
    } catch (error) {
        return [];
    }
};

async function fetchAllCategories() {
    const variantProductCollectionUuid = route.params.uuid as string;
    try {
        const { data } = await ApiService.get(`variant_product_collection_all_social_events`, {
            params: { 
                "variantProductCollection.uuid": variantProductCollectionUuid,
                itemsPerPage: 9999,
                page: 1
            },
            headers: { Accept: "application/ld+json" },
        });
        
        const allSocialEvents = data.data.socialEvents;
        const associatedEvents = data.data.associatedEvents || [];
        
        allSocialEvents.forEach((item, index) => {
            item.id = index;
            item.isAssociated = associatedEvents.some(event => event.uuid === item.uuid);
        });
        
        allCategories.value = allSocialEvents;
        
        updateTotalSelectedCategories();
    } catch (error) {
        console.error("Erreur lors de la récupération de toutes les catégories:", error);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    "form-class": isFormSubmitted.value ? 'hide' : 'show',
    onSubmit: submitHandler,
    actions: false
  }, {
    default: _withCtx(({ state: { valid } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(DataTable), {
          lazy: "",
          dataKey: "id",
          stateStorage: "local",
          ref: "dt",
          "state-key": getTableLocalStorageKey(),
          value: tableData.value,
          paginator: true,
          rows: rows.value,
          rowHover: true,
          sortMode: "multiple",
          removableSort: "",
          selection: selectedCategories.value,
          "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedCategories).value = $event)),
          metaKeySelection: false,
          loading: isLoading.value,
          totalRecords: totalRecords.value,
          currentPage: currentPage.value,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: rowsPerPageOptions,
          currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
          selectAll: isSelectAllBtnChecked.value,
          onSelectAllChange: _cache[3] || (_cache[3] = ($event: any) => (onRowSelectAll($event))),
          onRowSelect: _cache[4] || (_cache[4] = ($event: any) => (onRowSelect($event))),
          onRowUnselect: _cache[5] || (_cache[5] = ($event: any) => (onRowUnselect($event))),
          onPage: _cache[6] || (_cache[6] = ($event: any) => (onPaginate($event)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_unref(InputText), {
                      type: "text",
                      class: "w-9/12",
                      modelValue: criteria.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (onSearchInputDt()), ["prevent"]), ["enter"])),
                      placeholder: "Rechercher par catégorie URSSAF"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, "Nombre total de catégories URSSAF : " + _toDisplayString(totalRecords.value), 1),
                    _createElementVNode("p", null, "Nombre de catégorie(s) URSSAF sélectionnée(s) : " + _toDisplayString(totalSelectedCategories.value) + " marque(s)", 1),
                    (isInFilteredView.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Vous êtes en vue filtrée"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode("Aucun résultat trouvé.")
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(Column), { selectionMode: "multiple" }),
              _createVNode(_unref(Column), {
                field: "brand",
                header: "Catégorie URSSAF"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["state-key", "value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_FormKit, {
          type: "submit",
          label: "Enregistrer",
          disabled: !valid
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["form-class"]))
}
}

})